/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov, Slobodan Djordjevic
 */
import React, { useState } from "react"
import { formatAbbr } from "../trace/formatters"
import { Element, Avatar, Button, isSmallMobileScreen } from "trux"

const UserButton = ({ user, saveUrl, history, trk, ...props }) => {
    const [isHovering, setIsHovering] = useState(false)

    let trkLbl = ""
    let cn = "user-btn"

    if (user) {
        trkLbl = "User"
        if (user.traceid_playlist && user.traceid_playlist.image_url) {
            trkLbl += " Image"
        } else {
            trkLbl += " Abr"
        }
    } else {
        trkLbl = "Login"
    }

    const onClick = (e) => {
        history.replace(saveUrl)
    }

    return (
        <Element
            className={cn}
            trkAction={`${trkLbl} Pressed`}
            onClick={onClick}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            {...props}
        >
            {user && (
                <Avatar
                    imageUrl={`https://lapi.traceup.com/tracebot-${process.env.REACT_APP_TRACE_ENV}/avatars?user=${user.user_id}`}
                    size={40}
                    initials={formatAbbr(user).toUpperCase()}
                />
            )}
            {!user && isHovering && (
                <Button
                    className="hovering-button"
                    small
                    narrow={isSmallMobileScreen()}
                    ghost={isSmallMobileScreen()}
                    height={40}
                    content={"Sign in"}
                />
            )}
            {!user && !isHovering && (
                <Button
                    small
                    narrow={isSmallMobileScreen()}
                    ghost={isSmallMobileScreen()}
                    height={36}
                    content={"Sign in"}
                />
            )}
        </Element>
    )
}

export default UserButton
